export default [
    {
        key: "timestamp",
        label: "Timestamp",
        width: 3,
        sortable: true,
        sortAs: "timestamp",
        keyType: "text",
    },
    {
        key: "report_type",
        label: "Report Type",
        width: 4,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "user_name",
        label: "User Name",
        width: 2,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "job_pack_id",
        label: "Jobpack ID",
        width: 3,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },

    {
        key: "worksheet_status",
        label: "Status",
        width: 2,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "other",
        label: "Other Details",
        width: 4,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
];
